import {
  ChangeDetectionStrategy, Component, input, TemplateRef, viewChild,
} from '@angular/core'

@Component({
  selector: 'kb-navigation-content',
  imports: [],
  templateUrl: `./navigation-content.component.html`,
  styleUrl: './navigation-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationContentComponent {
  public id = input.required<string>()
  public content = viewChild.required(TemplateRef)
}
